export default "__VITE_ASSET__D05QfedZ__"